// @flow
import { REQUEST_DASHBOARD_DATA, RECEIVE_DASHBOARD_DATA } from '../../ActionsConst';

export const initialState = {
  isLoading: true,
  name: '',
  accountManager: {},
  orders: [],
};

const getAccountManagerDetails = (user) => {
  const { firstName, lastName, email, phone } = user.contacts.toPopulateProductPage;

  return {
    name: `${firstName} ${lastName}`,
    email,
    phone,
  };
};

const dashboard = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case REQUEST_DASHBOARD_DATA:
      return {
        ...state,
        isLoading: true,
      };
    case RECEIVE_DASHBOARD_DATA: {
      const { user, totalProducts, orders } = action;
      return {
        ...state,
        isLoading: false,
        name: user.name,
        totalProducts,
        accountManager: getAccountManagerDetails(user),
        orders,
      };
    }
    default:
      return state;
  }
};

export default dashboard;
